export default "__VITE_ASSET__DJEJJKtq__"